<!-- Notification card flutuante no canto inferior direito -->
<!-- Nao usa p-dialog para evitar qualquer interferencia com a UI -->
<div class="notificacao-flutuante"
     *ngIf="visivel && notificacao"
     [@slideIn]>

  <!-- Header -->
  <div class="notificacao-flutuante-header">
    <div class="notificacao-flutuante-header-left">
      <div class="notificacao-flutuante-icone-wrapper">
        <i class="pi pi-bell"></i>
      </div>
      <span class="notificacao-flutuante-titulo">{{ texts.titulo }}</span>
    </div>
    <button class="notificacao-flutuante-fechar-btn"
            (click)="onFechar()"
            type="button"
            title="Fechar">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Barra de progresso do auto-dismiss -->
  <div class="notificacao-flutuante-progress-bar" *ngIf="progressoAutoDismiss > 0">
    <div class="notificacao-flutuante-progress-fill"
         [style.width.%]="progressoAutoDismiss">
    </div>
  </div>

  <!-- Body -->
  <div class="notificacao-flutuante-body">
    <!-- Codigo do pedido -->
    <div class="notificacao-flutuante-pedido-numero">
      {{ texts.pedido_numero }}
    </div>

    <!-- Cliente -->
    <div class="notificacao-flutuante-info-row">
      <span class="notificacao-flutuante-label">{{ texts.cliente }}:</span>
      <span class="notificacao-flutuante-valor">{{ notificacao.nomeCliente }}</span>
    </div>

    <!-- Estado -->
    <div class="notificacao-flutuante-info-row">
      <span class="notificacao-flutuante-label">{{ texts.estado }}:</span>
      <span class="notificacao-flutuante-estado-badge" [style.background-color]="getCorEstado()">
        <i [class]="getIconeEstado()"></i>
        {{ notificacao.estadoAtual }}
      </span>
    </div>

    <!-- Horario -->
    <div class="notificacao-flutuante-hora">
      {{ formatarHora() }}
    </div>
  </div>

  <!-- Footer -->
  <div class="notificacao-flutuante-footer">
    <button pButton
            [label]="texts.fechar"
            class="p-button-text p-button-sm"
            (click)="onFechar()"
            type="button">
    </button>
    <button pButton
            [label]="texts.ver_pedido"
            icon="pi pi-eye"
            class="p-button-primary p-button-sm"
            (click)="onVerPedido()"
            type="button">
    </button>
  </div>
</div>
